import { Injectable } from '@angular/core';
import { UntypedFormControl, AbstractControl } from '@angular/forms';
import { StringUtility } from '../../../utility/string-utility';
import { ErrorDefinition } from '../../models/error-definition';

// This service returns the generic error messages for the inputs
@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  // Get standard errors for inputs
  getGenericErrors(formControl: AbstractControl, fgInfo: any): ErrorDefinition[] {
    return [
      this.createErrorDefinition(
        formControl,
        'minlength',
        `${fgInfo.label} must be at least ${StringUtility.toWord(
          fgInfo.minLength,
        )} characters long.`,
      ),
      this.createErrorDefinition(
        formControl,
        'maxlength',
        fgInfo.maxLengthMessage && fgInfo.maxLengthMessage.length
          ? `${fgInfo.maxLengthMessage}`
          : `${fgInfo.label} must be at most ${StringUtility.toWord(
            fgInfo.maxLength,
          )} characters long.`,
      ),
      this.createErrorDefinition(
        formControl,
        'required',
        fgInfo.requiredMessage?.length
          ? fgInfo.requiredMessage
          : fgInfo.label?.length
            ? `${fgInfo.label} is required.`
            : 'required',
      ),
      this.createErrorDefinition(
        formControl,
        'min',
        `${fgInfo.label} must be at least ${StringUtility.toWord(fgInfo.minValue)}.`,
      ),
      this.createErrorDefinition(
        formControl,
        'max',
        `${fgInfo.label} must be at most ${StringUtility.toWord(fgInfo.maxValue)}.`,
      ),
      this.createErrorDefinition(formControl, 'pattern', `${fgInfo.regularExpressionMessage}`),
      this.createErrorDefinition(
        formControl,
        'rangeInput',
        'Please enter valid input between 1 to 20',
      ),
      this.createErrorDefinition(
        formControl,
        'condrequired',
        fgInfo.requiredIf?.errorMessage?.length
          ? `${fgInfo.requiredIf.errorMessage}`
          : `${fgInfo.label} is required.`,
      ),
      this.createErrorDefinition(
        formControl,
        'email',
        `${fgInfo.label} must be a valid email address.`,
      ),
    ];
  }

  // Only return the required ErrorDefinitions because those are the only ones that apply to bool inputs
  getGenericBoolErrors(formControl: AbstractControl, fgInfo: any) {
    return this.getGenericErrors(formControl, fgInfo).filter(
      (value: ErrorDefinition) => value.key === 'condrequired' || value.key === 'required',
    );
  }

  // Returns an Error Definition to be used with a dynamic form input
  // If message is provided, it will display that static message
  // If message is omitted, it will display the ValidationError message for the given key on the FormControl
  createErrorDefinition(formControl: AbstractControl, key: string, message?: string) {
    if (message) {
      return new ErrorDefinition(
        key,
        () => formControl.hasError(key),
        this.convertMessageToFn(message),
      );
    } else {
      return new ErrorDefinition(
        key,
        () => formControl.hasError(key),
        (fc: UntypedFormControl) => `${fc.getError(key)}`,
      );
    }
  }

  // Shortcut for creating errors
  convertMessageToFn(message: string): () => string {
    return () => message;
  }
}
